"use client";
import { ProjectStoreProvider } from "@/components/provider/project-store-provide";
import { I18nextProvider, initReactI18next } from "react-i18next";
import i18n from "../../../../i18n";
import { getCookie, setCookie } from "cookies-next";
import { LanguageContext } from "./language-context";
import { useState, useMemo, useEffect } from "react";
import ConsoleSuppressor from "../../ConsoleSuppressor";
import Loading from "@/app/loadingg";
import DynamicCanonicalLink from "@/components/seo/DynamicCanonicalLink";

export default function ClientLayout({
  children,
  paramsLang = "en",
}: {
  children: React.ReactNode;
  paramsLang?: string;
}): React.ReactElement {
  // Initialize with paramsLang to avoid hydration mismatch
  const [lang, setLang] = useState(paramsLang);
  const [isLoaded, setIsLoaded] = useState(false);

  const language = useMemo(
    () => ({
      changeLanguage: (language: string) => {
        setLang(language);
        setCookie("lang", language);
      },
      language: lang,
    }),
    [lang]
  );

  useEffect(() => {
    // Only run on client side after hydration
    const langCookie = getCookie("lang") as string;

    // Prioritize URL param, then cookie, then default
    const finalLang = paramsLang || langCookie || "en";

    // Set cookie if not exists or different from URL param
    if (!langCookie || (paramsLang && langCookie !== paramsLang)) {
      setCookie("lang", finalLang);
    }

    setLang(finalLang);
    setIsLoaded(true);
  }, [paramsLang]);

  useEffect(() => {
    // if (isLoaded && lang) {
    i18n.use(initReactI18next).init({
      lng: lang,
      fallbackLng: "en",
    });
    // }
  }, [lang]);
  // }, [lang, isLoaded]);

  useEffect(() => {
    // if (lang === "ar") {
    if (lang === "ar" && isLoaded) {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = "/assets/css/rtl.css";
      link.setAttribute("data-rtl", "true");
      // Remove any existing RTL stylesheet
      const existingRTL = document.querySelector('link[data-rtl="true"]');
      if (existingRTL) {
        document.head.removeChild(existingRTL);
      }
      document.head.appendChild(link);
      return () => {
        const rtlLink = document.querySelector('link[data-rtl="true"]');
        if (rtlLink) {
          document.head.removeChild(rtlLink);
        }
      };
    }
    // }, [lang]);
  }, [lang, isLoaded]);

  // Show loader during hydration to prevent mismatch
  if (!isLoaded) {
    return (
      <ProjectStoreProvider>
        <div>
          <ConsoleSuppressor />
          <Loading />
        </div>
      </ProjectStoreProvider>
    );
  }

  return (
    <ProjectStoreProvider>
      <LanguageContext.Provider value={language}>
        <I18nextProvider i18n={i18n}>
          <div
            style={{
              direction: lang === "ar" ? "rtl" : "ltr",
            }}
            className={lang === "ar" ? "rtl arabic-font" : "main-font"}
          >
            <ConsoleSuppressor />
            <DynamicCanonicalLink lang={lang} />
            {children}
          </div>
        </I18nextProvider>
      </LanguageContext.Provider>
    </ProjectStoreProvider>
  );
}
